// src/pages/Home/Homepage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Typography, Space, Tag, Button } from "antd";
import {
  CalendarOutlined,
  UserOutlined,
  FireOutlined,
} from "@ant-design/icons";
import BlogLayout from "../../components/BlogLayout";
import Sidebar from "../../components/Sidebar";
import {
  useAuth,
  usePosts,
  useTags,
  usePopularPosts,
} from "../../hooks/useBlogAPI";
import BlogPostList from "../../components/BlogPostList";

const { Title } = Typography;

const HomePage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data: posts, loading } = usePosts(1, 5);
  const { data: tags } = useTags();
  const { data: popularPosts } = usePopularPosts(5);

  const handleCreatePost = () => {
    navigate("/posts/create");
  };

  const handleReadMore = (postId) => {
    navigate(`/posts/${postId}`);
  };

  return (
    <BlogLayout user={user} onCreatePost={handleCreatePost}>
      <div className="container">
        <Row gutter={[24, 24]}>
          <Col xs={24} lg={16}>
            <Card
              title={
                <div className="ink-title-decor">
                  <Title level={2}>最新文章</Title>
                </div>
              }
            >
              <BlogPostList
                posts={posts}
                loading={loading}
                onReadMore={handleReadMore}
              />
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Sidebar
              popularTags={tags || []}
              popularPosts={popularPosts || []}
            />
          </Col>
        </Row>
      </div>
    </BlogLayout>
  );
};

export default HomePage;
